import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { PDF_MADE_BY_MARPPLE_EDITOR } from '../Constant/pdf.js';

export const is_pdf_uploaded_by_customer = ({ pdf_printing_file }) =>
  UtilS.isNotEmpty(pdf_printing_file) && pdf_printing_file?.file_name !== PDF_MADE_BY_MARPPLE_EDITOR + '.pdf';
